<template>
  <label class="form-group fastaccess">
    Visa endast bostäder med omgående tillträde.
    <input type="checkbox" :checked="checked" @change="change()" />
    <span class="checkmark"></span>
  </label>
</template>
<script>
import { mapGetters } from 'vuex';
import { dataLayerPush } from '@/helpers/datalayer';

export default {
  data() {
    return {
      value__: this.checked,
    };
  },
  props: {
    checked: {
      required: false,
    },
  },
  watch: {
    /**
     * När v-model ändras, ska även det interna värdet ändras.
     * Detta sker t.ex. när man klickar på "Rensa"-knappen
     */
    checked: {
      handler() {
        this.value__ = this.checked;
      },
    },
  },
  methods: {
    change() {
      this.value__ = !this.value__;
      if (this.value__ == true) dataLayerPush({ event: 'omgaendeTilltrade' });

      this.$emit('update:checked', this.value__);
    },
  },
};
</script>


<style lang="scss" scoped>

.form-group.fastaccess {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 25px;
  margin-bottom: 30px;
  padding-left: 36px;
  position: relative;
  cursor: pointer;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  @media (min-width: 1024px) {
    margin-bottom: 0;
  }
}

.fastaccess {
  label {
    text-transform: unset;
    font-weight: normal;
  }

  /* Hide the browser's default checkbox */
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid #007893;
    content: "";
    background: #FFF;
    overflow: hidden;
  }
  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
}



/* On mouse-over, add a grey background color */
.fastaccess.form-group:hover > .checkmark {
  background-color: #e6f4f8;
}

/* When the checkbox is checked, add a blue background */
.fastaccess.form-group input:checked ~ .checkmark {
  background-color: #007893!important;
}



/* Show the checkmark when checked */
.fastaccess.form-group input:checked ~ .checkmark:after {
  display: block;
  left: 2px;
  top: 2px;
  width: 18px;
  height: 18px;
  background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-checkbox.svg);
}


</style>
